export default __webpack_public_path__ + "media/paperTexture.e5cf8ccaf3893416be1ae663f599b2a3.webp";